/**
 * Single owner for the Provider-name column's width bounds (TD-07,
 * DEC-075). Before this module the column's FLOOR lived in
 * ProvidersTableView (`min-w-[200px]` on the header) while its CEILING
 * lived in ProviderRow (`max-w-[280px]` on the body cell) — one visual
 * outcome, two owners in two files, free to drift apart silently.
 * Both files now consume these constants so the column's 200–280 float
 * range is declared exactly once.
 *
 * Kept as a non-component sibling module (same pattern as
 * `gap-coverage-style.ts`) so the component files stay single-export
 * per `react-refresh/only-export-components`.
 */
export const PROVIDER_NAME_COL_MIN_CLASS = 'min-w-[200px]';
export const PROVIDER_NAME_COL_MAX_CLASS = 'max-w-name-col';
